<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'
import { MarketMakerAvatar } from '#ui-kit/blocks/avatars'
import ColumnCell from './ColumnCell.vue'

const props = defineProps<{
  name: string
  image?: string | null
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div :class="cn('flex min-w-0 items-center gap-2 px-2', props.class)">
    <MarketMakerAvatar :src="image" bordered class="shrink-0" />
    <ColumnCell :value="name" truncate class="p-0" />
  </div>
</template>
